import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  DashboardAtendimentoData,
  PeriodoDashboardAtendimento,
} from '../../types/dashboardAtendimento';

import { dashboardAtendimentoService } from './services';

export const fetchDashboardAtendimento = createAsyncThunk<
  DashboardAtendimentoData,
  PeriodoDashboardAtendimento,
  { rejectValue: string }
>('dashboardAtendimento/fetch', async (periodo, { signal, rejectWithValue }) => {
  try {
    return await dashboardAtendimentoService.get(periodo, signal);
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Erro ao carregar o dashboard de atendimento',
    );
  }
});
